import * as Dialog from '@radix-ui/react-dialog';
import React, { useState } from 'react';

import { BaseButton } from '../../../components/button/BaseButton';
import { CreateVatRateForm } from './CreateVatRateForm';
import { IMinimalVatRate } from './VatRateComboboxField';

export interface ICreateVatRateDialogProps {
  triggerText: React.ReactElement;
  onSubmit: (data: IMinimalVatRate) => void | Promise<void>;
}

export const CreateVatRateDialog: React.FC<ICreateVatRateDialogProps> = (props) => {
  const { triggerText, onSubmit } = props;
  const [open, setOpen] = useState(false);

  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Trigger asChild>
        <BaseButton>{triggerText}</BaseButton>
      </Dialog.Trigger>

      <Dialog.Portal>
        <Dialog.Overlay className="dialog-overlay" />
        <Dialog.Content className="dialog-content">
          <Dialog.Title className="heading-one mb-4">Maak btw type aan</Dialog.Title>

          <div>
            <CreateVatRateForm
              onCancel={() => setOpen(false)}
              onComplete={(data) => {
                onSubmit(data);
                setOpen(false);
              }}
            />
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
